import { gsap } from 'gsap';
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import jQuery from "jquery";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { Utils } from '../misc/Utils';

export class ProfilePageHandler extends PageHandler {
    constructor(id) {
    	super(id);
		this.testimonials = [];
    }

	tiWidgetToTestimonials() {
		var grid = document.querySelector('.section-content__testimonials');
		let i;
		var tests = document.querySelectorAll('.ti-review-item');
		tests.forEach((elem, index) => {
			var normalizedName = jQuery(elem).find('.ti-name').text().trim();
			var normalizedDate = jQuery(elem).find('.ti-date').text().trim()
			var normalizedText = jQuery(elem).find('.ti-review-text-container').text().trim();
			this.testimonials[index] = {
				name: normalizedName.split(' ')[0],
				date: normalizedDate,
				dateLocale: new Date(normalizedDate).toLocaleDateString('el-gr', { month:"long", year:"numeric"}),
				text: normalizedText
			}
		})

		this.testimonials.forEach((value, index) => {
			var template = `<div class="testimonial">
				<div class="testimonial-text">
					${value.text}
				</div>
				<div class="testimonial-author">${value.name}<span class="testimonial-date"> - ${value.dateLocale}</span></div>
			</div>`;
			jQuery('.section-content__testimonials').append(template);
		})

		window.profileMsnry = new Masonry( grid, {
			// options...
			itemSelector: '.testimonial',
			gutter: '.gutter-sizer',
			horizontalOrder: true
		});
		
	}

    init() {
		window.setTimeout(() => {
			this.tiWidgetToTestimonials()
			let mm = gsap.matchMedia();

			mm.add("(min-width: 769px)", () => {
				gsap.set('.testimonial', {autoAlpha: 0, y: 100} )
				ScrollTrigger.batch(".testimonial", {
					onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: {each: 0.15, grid: [1, 2]}, overwrite: true}),
				});
			})
	
			ScrollTrigger.create({
				trigger: '.section-content.approach',
				start: '50% bottom',
				onEnter: () => {
					Utils.fadeInUp('.section-content.approach .section-content__pane')
				},
				once: true
			})
	
			mm.add("(min-width: 769px) and (max-width: 1280px)", () => {
				const heading = document.querySelector(".section-content__left");
				gsap.to(heading, {
					scrollTrigger: {
						id: "pin",
						trigger: heading,
						start: "50% 50%",
						end: () => {
							var height2 = jQuery(heading).outerHeight();
							var top2 = window.innerHeight * 0.5 - height2/2.0;
							return `bottom 100%-=${top2}px`
						},
						endTrigger: '.section-content__right',
						pin: true,
						pinSpacing: false,
						pinType: "transform",
						invalidateOnRefresh: true
					}
				})
			})
		}, 2000);
		
		

    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
			
		imagesLoaded( document.querySelector('.profile .section-content.vision .section-content__left'), function (instance) {
			Utils.fadeInFrom('.profile .section-content.vision .section-content__left')
			Utils.fadeInUp('.profile .section-content.vision .section-content__right')
		})

		// gsap.fromTo('.profile .intro', {backgroundSize: "600%"}, {backgroundSize: "100%", duration: 0.5, ease: 'power2.inout'});

	}
}